module.exports = __webpack_public_path__ + "img/bg 03 orange.372b0706.png";